import paymentMethodStatuses from 'data/payment_method_statuses';

export default function getPaymentMethodInformation(paymentMethodStatus) {
  let information = paymentMethodStatuses.find((item) => item.value === paymentMethodStatus);
  if (information == null) {
    information = paymentMethodStatuses.find((item) => item.value === 'other');
  }
  return information;
}
